import './Home_HowWork.css';
import Divider from '../Divider';
const Home_HowWork = () => {
    return (
        <section className="workflow-wave-section">
        <h2 className="workflow-title">How NeatnClean Works</h2>
        <div className="workflow-path">
      
          <div className="workflow-steps">
            <div className="workflow-step" style={{ left: '5%' }}>
            <div className="workflow-card">
              <div className="bubble">
                <i className="fas fa-calendar-check"></i>
              </div>
              <h3>Schedule</h3>
              <p>Pick a time for pickup — we'll be at your door.</p>
              </div>
              <Divider topColor="#4c6fa2" bottomColor="#4c6fa2" thickness="10px" margin_side="0px" />
            </div>
            <div className="workflow-step" style={{ left: '30%' }}>
            <div className="workflow-card">
              <div className="bubble">
                <i className="fas fa-hand-holding"></i>
              </div>
              <h3>Collect</h3>
              <p>We collect your clothes from your doorstep.</p>
              </div>
              <Divider topColor="#4c6fa2" bottomColor="#4c6fa2" thickness="10px" margin_side="0px" />
            </div>
            <div className="workflow-step" style={{ left: '55%' }}>
            <div className="workflow-card">
              <div className="bubble">
                <i className="fas fa-soap"></i>
              </div>
              <h3>Clean</h3>
              <p>Washed, dried, ironed — just like new!</p>
              </div>
              <Divider topColor="#4c6fa2" bottomColor="#4c6fa2" thickness="10px" margin_side="0px" />
            </div>
            <div className="workflow-step" style={{ left: '80%' }}>
            <div className="workflow-card">
              <div className="bubble">
                <i className="fas fa-truck"></i>
              </div>
              <h3>Deliver</h3>
              <p>Delivered back within 24 hours, wrinkle-free.</p>
              </div>
              <Divider topColor="#4c6fa2" bottomColor="#4c6fa2" thickness="10px" margin_side="0px" />
            </div>
          </div>
        </div>
      </section>      
    );
  }

export default Home_HowWork;